module.exports = __webpack_public_path__ + "assets/img/honor3.c82b46c0.jpg";